export const employeesHierarchySelector = state => state.employeesHierarchy;
